<template>
    <div class="w100">
        <div class="notify-content"  v-loading="loading">
            <div  class="area" >
                <div id="printTest">
                <div class="area-title">
                    {{resData.name}}
                </div>
                <div class="area-info">
                    <span>发起部门：{{resData.launchDeptName}}</span>
                    <span>发布者：{{resData.username}}</span>
                    <span>发布时间：{{resData.createTime}}</span>
                    <span>浏览量：{{resData.pageViews || 0}}</span>
                </div>
                <div class="area-content ql-container ql-snow bor-none" >
                            <div class="ql-editor" v-html="resData.content">

                            </div>
                    <div class="area-content-attachIds"
                         v-if="resData.attachList&&resData.attachList.length">
                        <div class="left">
                            附件:
                        </div>
                        <div class="right">
                            <ul>
                                <li v-for="item in resData.attachList||[]">
                                    <el-button type="text" icon="el-icon-download"
                                               @click="downLoadFile(item)">{{item.fileName}}</el-button>
                                </li>
                            </ul>

                        </div>

                    </div>
                </div>
                </div>
                <div class="area-footer cl-f">
                    <!--<span class="fl" @click="$router.back()">-->
                        <!--<i class="el-icon-back"></i>-->
                        <!--返回-->
                    <!--</span>-->
                    <span class="fr ml10" @click="goTop">
                        <i class="el-icon-caret-top"></i>
                        返回顶部
                    </span>
                    <span class="fr mr10" v-print="'#printTest'">
                        <i class="el-icon-printer"></i>
                        打印
                    </span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import { getNoticeInfo} from '@/api/managementCenter/notification';
    import { handleDownload} from '@/api/managementCenter/otherApi';
    import { mapActions } from "vuex";
    let timer = null //定义初始值
    export default {
        name: "notifyDetail",
        components: {},
        props: [],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                loading:false,
                resData:{}
            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getNoticeInfoFn()

        },
        methods: {
            ...mapActions(["GetUnreadCount"]),
            getNoticeInfoFn(){
                this.loading = true;
                getNoticeInfo({id:this.$route.query.id}).then(({data})=>{
                    this.loading = false;
                    if(data.code==0){
                        this.resData=data.data||{};
                        this.GetUnreadCount();
                    }else{
                        this.$message.error( data.msg ||"获取通知信息失败！" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },
            goTop() {
                timer = setInterval(function () {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
                    if (osTop === 0) {
                        clearInterval(timer)
                    }
                },30)
            },
            downLoadFile(item){
                this.$DownLoad(
                    handleDownload(item.fileId),
                    null,
                    res => {
                        if (res.status == 200) {
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );
            },

        },
        destroyed() {

        },
        watch: {

        },
        filters: {},
    };
</script>

<style scoped lang="less" >
    .notify-content{
        width: 900px;
        padding-top: 25px;
        margin: 0 auto;
    }
    .area{

        background: #FFFFFF;
        width: 800px;
        margin: 0 auto;
        padding: 40px 40px;
        border-radius: 5px;
        overflow: hidden;
        &-title{
            font-size: 22px;
            padding-bottom: 30px;
            font-weight: bold;
            text-align: center;
            font-family: Microsoft YaHei;
            color: #666666;
        }
        &-info{
            color: #cccccc;
            text-align: center;
            border-bottom:1px solid #EEEEEE;
            padding-bottom: 5px;
            font-size: 13px;
            margin-bottom: 20px;
            >span{
                display: inline-block;
                padding-right: 20px;
            }
            }
        &-content{
            min-height: 600px;
            padding: 10px;
            &-attachIds{
                display: flex;
                .left{
                    width: 60px;
                    text-align: center;
                    font-weight: bold;
                    padding-top: 8px;
                    color: #cccccc;
                }
                .right{
                    flex: 1;
                }

            }
        }
        &-footer{
            width: 720px;
            margin: 0 auto;
            padding-top: 20px;
            color: #cccccc;
            >span{
                cursor: pointer;
            }
        }


    }

</style>
